import React, { useEffect, useState } from "react";
import {
  Button,
  Collapse,
  Modal,
  Input,
  Form,
  theme,
  Spin,
  Tooltip,
  Popconfirm,
  ColorPicker,
} from "antd";
import { useNavigate } from "react-router-dom";
import {
  createLevelapi,
  createModuleapi,
  createTarget,
  getLearningapi,
  lessonArchive,
  lessonUnArchive,
  levelArchive,
  levelUnArchive,
  moduleArchive,
  moduleUnArchive,
  updateLevelApi,
  updateLevelOrder,
  updateLessonsOrder,
  updateModuleOrder,
  updateModuleApi,
} from "../../store/services/curriculum";

import "../Curriculum/Curriculum.css";

import TargetModel from "../Modals/targetModal/targetModals";
import { LuPlus } from "react-icons/lu";
import { IoIosArrowDown } from "react-icons/io";
import { checkRoutePermissions } from "../../utils/permission";
import NotAccess from "../../pages/NotAccess";
import { MdOutlineArchive } from "react-icons/md";
import moment from "moment";
import DragAndDrop from "../DragAndDrop";
import { sortLessonByOrder } from "../../utils";
import clock from "../../assets/Clock.png";
import DragAndDropCollapse from "../DraggableCollapse";
import LevelDragAndDrop from "../LevelDragAndDrop";
const { Panel } = Collapse;

interface TargetFormValues {
  target: string;
}
interface CurriculumDetailsProps {
  cId: any;
  data?: any;
}

const CurriculumDetails: React.FC<CurriculumDetailsProps> = ({ cId, data }) => {
  const [isLevelModalVisible, setIsLevelModalVisible] = useState(false);
  const [isModuleModalVisible, setIsModuleModalVisible] = useState(false);
  const [isModalOpens, setIsModalOpens] = useState(false);
  const [currentModule, setCurrentModule] = useState<string>("");
  const [currentLevel, setCurrentLevel] = useState<string>("");
  const [load, setLoad] = useState(false);
  const [currentLevelId, setCurrentLevelId] = useState<number>();
  const [levels, setLevels] = useState<any>(null);
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState<string>("main");
  const [loading, setLoading] = useState(false);
  const [orderLoading, setOrderLoading] = useState(false);
  const [hoveredPanel, setHoveredPanel] = useState<number | null>(null);
  const [levelValues, setLevelValues] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const { token } = theme.useToken();
  const subjectId = cId;
  const navigate = useNavigate();
  const [colorRgb, setColorRgb] = useState<any>("rgb(0, 0, 0)");

  const rgbString =
    typeof colorRgb === "string" ? colorRgb : colorRgb?.toRgbString();


  const handleAddTarget = (module: string, level: string) => {
    setCurrentLevel(level);
    setCurrentModule(module);
    setIsModalOpens(true);
    setIsEdit(false);
  };

  const handleAddModule = (levelId: number) => {
    setCurrentLevelId(levelId);
    setIsModuleModalVisible(true);
    setIsEdit(false);
    setColorRgb("rgb(0, 0, 0)");
  };

  const handleEditModule = (module: any) => {
    setCurrentLevelId(module?.moduleId);
    setIsModuleModalVisible(true);
    setIsEdit(true);
    form.setFieldValue("module", module?.name);
    setColorRgb(module?.color);
  };

  const handleEditLevel = (level: any) => {
    setCurrentLevelId(level.levelId);
    setIsLevelModalVisible(true);
    setIsEdit(true);
    setLevelValues(level?.level);
    setColorRgb(level?.color);
  };

  const getData = async (isSync?: boolean, isLoading: boolean = true) => {
    isLoading && setIsLoading("main");

    const idAsNumber = parseInt(subjectId ?? "");
    const response = await getLearningapi({
      subjectId: idAsNumber,
      isSync: isSync ? true : false,
    });
    if (response) {
      const newLevels = response.newLevelList.map((newLevel: any) => {
        const modules = newLevel.modules.map((module: any) => ({
          name: module.moduleName,
          targets: module.lessonsList.map((lesson: any) => lesson),
          moduleId: module.moduleId,
          status: module.status,
          color: module.color,
          orderNo: module.orderNo,
        }));

        const { levelId } = newLevel;
        setCurrentLevelId(newLevel.levelId);
        return {
          level: newLevel.levelName,
          status: newLevel.status,
          modules: modules,
          levelId: levelId,
          color: newLevel.color,
          orderNo: newLevel.orderNo,
        };
      });
      setLevels(newLevels);
    }

    isLoading && setIsLoading("");
  };

  useEffect(() => {
    getData();
  }, [subjectId]);

  const handleAddLevel = async (values: any, subjectId: string | undefined) => {
    try {
      setLoad(true);

      setIsLoading("level");

      let res;
      if (isEdit) {
        const updateLevels = {
          levelName: values,
          levelId: currentLevelId,
          color: rgbString,
        };
        res = await updateLevelApi(updateLevels);
      } else {
        const idAsNumber = subjectId ? parseInt(subjectId) : undefined;
        const payload: any = {
          levelName: values,
          subjectId: idAsNumber,
          color: rgbString,
        };
        res = await createLevelapi(payload);
      }

      //@ts-ignore

      if (res) {
        form.resetFields();
        setIsLevelModalVisible(false);
        setLoad(false);
        return res;
      } else {
        setIsLoading("");
        setLoad(false);
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoad(false);
    }
    // setIsLoading("");
  };

  const handleModuleModalOk = async (values: any) => {
    const moduleData = {
      moduleName: values.module,
      levelId: currentLevelId,
      color: rgbString,
    };

    setIsLoading("module");

    try {
      let res;

      if (isEdit) {
        const updateLevels = {
          moduleName: values.module,
          moduleId: currentLevelId,
          color: rgbString,
        };
        res = await updateModuleApi(updateLevels);
      } else {
        res = await createModuleapi(moduleData);
      }

      if (res) {
        form.setFieldValue("module", undefined);
        setIsModuleModalVisible(false);
        await getData(true);
      }
    } catch (error) {
      console.error("Error updating or creating module:", error);
    } finally {
      setIsLoading(""); // Reset loading state
    }
  };

  const handleTargetClick = (
    target: string,
    currentLevelData: any,
    currentModuleId: any
  ) => {
    navigate(`/lessondetails/${target}`, {
      state: { currentLevelData, currentModuleId, data },
    });
  };

  const sendData = async () => {
    try {
      const levelToSend = levelValues;
      await handleAddLevel(levelToSend, subjectId);
      getData(true);
      setIsLevelModalVisible(false);
    } catch (error) {
      console.log("error", error);
    }
  };

  const addLevel = () => {
    setIsEdit(false);
    setIsLevelModalVisible(true);
    setLevelValues(`level-${levels?.length + 1}`);
    setColorRgb("rgb(0, 0, 0)");
  };

  const levelArch = async (levelId: any) => {
    setLoading(true);
    const res = await levelArchive({ levelId: levelId });
    if (res) getData(true);
    setLoading(false);
  };

  const addArchiveLesson = async (id: any) => {
    setLoading(true);
    const res = await lessonArchive({ lessonId: id });
    if (res) getData(true);
    setLoading(false);
  };

  const addArchiveModule = async (id: any) => {
    setLoading(true);
    const res = await moduleArchive({ moduleId: id });
    if (res) getData(true);
    setLoading(false);
  };

  const handleLevelModalCancel = () => {
    setColorRgb("rgb(0, 0, 0)");
    setIsLevelModalVisible(false);
  };

  const handleModuleModalCancel = () => {
    setIsModuleModalVisible(false);
    setColorRgb("rgb(0, 0, 0)");
    form.setFieldValue("module", undefined);
  };

  const getLessonLength = (level: any) => {
    let length = 0;
    level?.modules?.map((module: any) => {
      length += module?.targets?.length;
    });
    return length;
  };

  const updateLevelDnD = async (
    levelId: Number,
    moduleId: Number,
    targets: any
  ) => {
    const temp = [...levels];
    const forUpdate = {
      moduleId,
      targets,
    };
    console.log("🚀 ~ forUpdate: in dnd", forUpdate)

    const updatedArr = temp.map((level) => {
      if (level.levelId === levelId) {
        return {
          ...level,
          modules: level?.modules?.map((module: any) =>
            module?.moduleId === moduleId
              ? {
                  ...module,
                  targets: targets.map((v: any, i: number) => {
                    return {
                      ...v,
                      orderNo: i + 1,
                    };
                  }),
                }
              : module
          ),
        };
      }
      return level;
    });

    setLevels(updatedArr);
    setOrderLoading(true);
    const res = await updateLessonsOrder(forUpdate);
    if (res) {
      await getData(true, false);
    }
    setOrderLoading(false);
  };

  const updateLevelModule = async (
    levelId: Number,
    modules: any
  ) => {
    const temp = [...levels];
    const forUpdate = {
      levelId,
      modules,
    };
    console.log("🚀 ~ forUpdate:", forUpdate)

    const updatedArr = temp.map((level) => {
      if (level.levelId === levelId) {
        return {
          ...level,
          modules: modules?.map((module: any, i: number) => {
            return {
              ...module,
              orderNo: i + 1,
            };
          }),
        };
      }
      return level;
    });
    // console.log("🚀 ~ updatedArr ~ updatedArr:", updatedArr)

    setLevels(updatedArr);
    setOrderLoading(true);
    const res = await updateModuleOrder(forUpdate);
    if (res) {
      await getData(true, false);
    }
    setOrderLoading(false);
  };  

  const updateOrderOfLevel = async (
    subjectId: Number,
    levelsArr: any
  ) => {
    const forUpdate = {
      subjectId,
      levelsArr,
    };
    console.log("🚀 ~ forUpdate: in leve;", forUpdate)

    const updatedArr = levelsArr.map((level : any, i : number) => {
      return {
        ...level,
        orderNo: i + 1,
      };
    });
    // console.log("🚀 ~ updatedArr ~ updatedArr:", updatedArr)

    setLevels(updatedArr);
    setOrderLoading(true);
    const res = await updateLevelOrder(forUpdate);
    // if (res) {
    //   await getData(true, false);
    // }
    setOrderLoading(false);
  };

  return checkRoutePermissions("curriculumDetails") ? (
    <div className="_curriculumDetailsContainer">
      {orderLoading && (
        <div className="_loadingOverlay">
          <Spin /> <p>Updating Order...</p>
        </div>
      )}
      <div className="maindivdetails">
        <div className="_heading"></div>

        <TargetModel
          isModalOpens={isModalOpens}
          currentModule={currentModule}
          setIsModalOpens={setIsModalOpens}
          getData={getData}
        />

        <div className="levelbtndiv">
          {levels && (
            <Button className="black-button" onClick={() => addLevel()}>
              <LuPlus size={20} />
              &nbsp;Add a level
            </Button>
          )}
          {isLoading !== "main" && (
            <Button className="black-button" onClick={() => getData(true)}>
              Sync Changes
            </Button>
          )}
          <div></div>
        </div>

        {isLoading === "main" ? (
          <div className="_isLoading">
            <Spin />
          </div>
        ) : (
          <div className="curriculumDetailLevel">
            {levels && levels.length > 0 ? (
              <LevelDragAndDrop
                items={sortLessonByOrder(levels)}
                setItems={(levelsArr: any) =>
                  updateOrderOfLevel(subjectId, levelsArr)
                }
                loading={false}
                addArchiveModule={addArchiveModule}
                handleAddTarget={handleAddTarget}
                handleEditModule={handleEditModule}
                updateLevelDnD={updateLevelDnD}
                handleTargetClick={handleTargetClick}
                addArchiveLesson={addArchiveLesson}
                getLessonLength={getLessonLength}
                handleAddModule={handleAddModule}
                handleEditLevel={handleEditLevel}
                updateLevelModule={updateLevelModule}
                levelArch={levelArch}
              />
            ) : (
              <div className="module_curriculum">No Data Found</div>
            )}
          </div>
        )}

        {levels && (
          <Modal
            title={
              <span className="levelTitle">
                {isEdit ? "Edit Level" : "Add Level"}
              </span>
            }
            open={isLevelModalVisible}
            onCancel={handleLevelModalCancel}
            footer={null}
            className="custom-modal"
            centered
          >
            {/* <Form
            layout={"vertical"}
            onFinish={(values) => handleAddLevel(values, subjectId)}
          >
            <Form.Item
              name="levelName"
              label="Level"
              className="level"
              rules={[
                { required: true, message: "Please input the level name!" },
              ]}
            >
              <Input placeholder="Add level" />
            </Form.Item>
            <div className="btn-parent">
              <Button
                onClick={() => setIsLevelModalVisible(false)}
                style={{ backgroundColor: "white", color: "black" }}
              >
                Cancel
              </Button>
              <Button
                loading={isLoading === "level"}
                disabled={isLoading === "level"}
                htmlType="submit"
                style={{
                  backgroundColor: "var(--secondary-color)",
                  color: "white",
                }}
              >
                Add Level
              </Button>
            </div>
          </Form> */}
            <label className="label_curriculum">
              {" "}
              <span className="required_icon_input">*</span> Level
            </label>
            <input
              value={levelValues}
              className="curriDetails"
              type="text"
              placeholder="Add Level"
              onChange={(e) => {
                setLevelValues(e.target.value);
              }}
            />
            <label className="label_curriculum">Pick Color</label>
            <br />
            <ColorPicker
              className="color_picker"
              format="rgb"
              value={colorRgb}
              onChange={setColorRgb}
            />
            <br />
            <br />
            <div className="btn-parent">
              <Button
                onClick={() => setIsLevelModalVisible(false)}
                disabled={load}
                style={{ backgroundColor: "white", color: "black" }}
              >
                Cancel
              </Button>
              <Button
                loading={load}
                disabled={load}
                // htmlType="submit"
                onClick={sendData}
              >
                {isEdit ? " Edit Level" : " Add Level"}
              </Button>
            </div>
          </Modal>
        )}

        <Modal
          title={
            <span className="levelTitle">
              {isEdit ? "Edit Module" : "Add Module"}
            </span>
          }
          open={isModuleModalVisible}
          onCancel={handleModuleModalCancel}
          footer={null}
          className="custom-modal"
          centered
        >
          <Form form={form} onFinish={handleModuleModalOk} layout="vertical">
            <Form.Item
              name="module"
              label="Module"
              rules={[
                { required: true, message: "Please input the module name!" },
              ]}
            >
              <Input placeholder="Add a Module" />
            </Form.Item>
            <Form.Item label="Pick Color">
              <ColorPicker
                className="color_picker"
                format="rgb"
                value={colorRgb}
                onChange={setColorRgb}
              />
            </Form.Item>

            <div className="btn-parent">
              <Button
                onClick={() => {
                  setIsModuleModalVisible(false);
                  form.setFieldValue("module", undefined);
                }}
                disabled={isLoading === "module"}
                style={{ backgroundColor: "white", color: "black" }}
              >
                Cancel
              </Button>
              <Button
                loading={isLoading === "module"}
                disabled={isLoading === "module"}
                htmlType="submit"
              >
                {isEdit ? "Edit Module" : "Add Module"}
              </Button>
            </div>
          </Form>
        </Modal>
      </div>
    </div>
  ) : (
    <NotAccess />
  );
};

export default CurriculumDetails;
